import {
  ANNUAL_WHEEL_SPREAD_DEFINITION,
  PAST_PRESENT_FUTURE_SPREAD_DEFINITION,
  type SpreadDefinition,
} from './core';
import { createSpreadDefinition } from '../internal/builders';

export const TIMELINE_SPREAD_DEFINITION: SpreadDefinition = createSpreadDefinition({
  id: 'timeline',
  name: 'Timeline',
  slug: 'timeline',
  category: 'special',
  description: 'Cinque stazioni temporali per leggere progressione, attrito e passaggio.',
  ritual_note: null,
  opening_invocation: null,
  closing_words: null,
  difficulty: 'intermediate',
  is_lilith: false,
  tree_of_life_mapping: false,
  family: 'line',
  intent: ['timeline', 'clarity', 'yearly'],
  semantic_tags: ['temporal', 'forecast', 'diagnostic'],
  layout_id: 'line-5',
  position_specs: [
    { role_id: 'past', description: 'Che cosa ha acceso il processo?' },
    { role_id: 'present', description: 'Che fase è attiva adesso?' },
    { role_id: 'challenge', description: 'Quale soglia o attrito segna il passaggio centrale?' },
    { role_id: 'action', description: 'Quale gesto modifica davvero la traiettoria?' },
    { role_id: 'future', description: 'Quale fase viene dopo?' },
  ],
  keywords: ['timeline', 'fasi', 'passaggio', 'sviluppo'],
  recommended_for_questions: [
    'Come si muove questo processo nel tempo?',
    'Quale passaggio devo attraversare per cambiare fase?',
  ],
  contraindications: ['Non ideale per leggere una struttura relazionale a più poli.'],
  focus_mode_ids: [],
  ritual_intensity: 2,
});

export const LIFE_CYCLE_SPREAD_DEFINITION: SpreadDefinition = createSpreadDefinition({
  id: 'life-cycle',
  name: 'Life Cycle',
  slug: 'life-cycle',
  category: 'special',
  description: 'Nove nodi per osservare un ciclo completo: origine, sviluppo, crisi, risorsa e integrazione.',
  ritual_note: 'Utile quando vuoi vedere un intero ciclo e non solo il prossimo passo.',
  opening_invocation: null,
  closing_words: null,
  difficulty: 'advanced',
  is_lilith: false,
  tree_of_life_mapping: false,
  family: 'grid',
  intent: ['timeline', 'yearly', 'spiritual'],
  semantic_tags: ['temporal', 'initiatic', 'self-study'],
  layout_id: 'custom-grid-9',
  position_specs: [
    { role_id: 'message', name: 'Origine', description: 'Quale seme apre il ciclo?' },
    { role_id: 'past', name: 'Memoria', description: 'Che cosa accompagna il ciclo da dietro?' },
    { role_id: 'present', name: 'Attuale', description: 'Quale fase è in atto adesso?' },
    { role_id: 'challenge', name: 'Crisi', description: 'Quale crisi o attrito segna il centro?' },
    { role_id: 'hidden', name: 'Sottotraccia', description: 'Che cosa lavora silenziosamente?' },
    { role_id: 'resource', name: 'Riserva', description: 'Quale sostegno esiste già?' },
    { role_id: 'future', name: 'Sviluppo', description: 'Quale sviluppo si prepara?' },
    { role_id: 'ritual_action', name: 'Passaggio', description: 'Quale gesto aiuta la transizione?' },
    { role_id: 'integration', name: 'Integrazione', description: 'Che cosa viene compreso o consolidato?' },
  ],
  keywords: ['ciclo', 'evoluzione', 'nove nodi', 'visione lunga'],
  recommended_for_questions: [
    'Sto vivendo una fase lunga e voglio vederne l’intero disegno.',
    'Qual è la logica del ciclo in cui mi trovo?',
  ],
  contraindications: ['Non ideale per daily draw o per domande con un singolo bivio pratico.'],
  focus_mode_ids: [],
  ritual_intensity: 3,
});

export const TEMPORAL_SPREAD_DEFINITIONS: SpreadDefinition[] = [
  PAST_PRESENT_FUTURE_SPREAD_DEFINITION,
  TIMELINE_SPREAD_DEFINITION,
  LIFE_CYCLE_SPREAD_DEFINITION,
  ANNUAL_WHEEL_SPREAD_DEFINITION,
];
